import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { SharedModule } from './shared/shared.module';
import { HomeModule } from './home/home.module';
import { ProductsModule } from './products/products.module';
import { PageMetaModule } from './page-meta';
import { provideCtrlIcons } from '@co-3/ctrl-ui/icons';
import { icons } from '@config/icons.config';
import { provideDefaultWidgets } from '@models/contract-widgets';
import { defaultContractWidgets } from '@config/default-contract-widgets';
import { provideFeatureFlags } from './core/feature-flags/feature-flags.service';
import { features } from 'environments/features';
import { CookieSettingsComponent } from './core/cookie-settings/cookie-settings.component';
import { CtrlTooltipsModule } from '@co-3/ctrl-ui/tooltips';
import { HeaderComponent } from '@core';
import { FooterComponent } from './core/components/footer/footer.component';

registerLocaleData(localeDe);

@NgModule({
    declarations: [AppComponent, routingComponents],
    imports: [
        FooterComponent,
        BrowserModule,
        HomeModule,
        CoreModule.forRoot(),
        AppRoutingModule,
        SharedModule,
        ProductsModule,
        HeaderComponent,
        CookieSettingsComponent,
        PageMetaModule.forRoot({
            default: {
                title: 'astra Versicherung AG - Wir versichern, was Sie lieben',
                description:
                    'Die astra Versicherung AG ist der günstige Online-Spezialanbieter mit attraktiven Versicherungslösungen für Privatpersonen in nahezu allen Bereichen.',
            },
        }),
        CtrlTooltipsModule.forRoot({ position: 'center-top', offsetY: 16 }),
    ],
    providers: [
        provideFeatureFlags(features),
        { provide: LOCALE_ID, useValue: 'de' },
        Title,
        CurrencyPipe,
        provideCtrlIcons(icons),
        provideDefaultWidgets(defaultContractWidgets),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
